import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../Header/Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCaretDown} from "@fortawesome/free-solid-svg-icons";
import Stickeyheader from "./Stickeyheader";
import axios from "axios";
const Header = () => {
  const [slide, setSlide] = useState(false);
  const [nav, setNav] = useState(false);
  const cursorRef = useRef(null);
  const cursorInnerRef = useRef(null);
  const [isHoveringLink, setIsHoveringLink] = useState(false);
  const [isClicking, setIsClicking] = useState(false);
  const [certificates, setCertificates] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null); 


  const handleDropdownToggle = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown); // Toggle between open and closed
  };

  // const logout = () => {
  //   localStorage.removeItem('isLoggedIn');
  //   localStorage.removeItem('isInstitutionLogin');

  //   window.location.reload(); // Reload to update the UI after logout
  // };

  // const handleclick = () => {
  //   setSlide(!slide);
  // };

  const handleMobileNavToggle = () => {
    setNav(!nav);
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/details/getCertificates`)
      .then((response) => {
        setCertificates(response.data);
      })
      .catch((error) => {
        console.error("Error fetching certificates:", error);
      });

    const cursor = cursorRef.current;
    const cursorInner = cursorInnerRef.current;

    if (cursor && cursorInner) {
      const handleMouseMove = (e) => {
        const { clientX, clientY } = e;
        cursor.style.transform = `translate3d(calc(${clientX}px - 50%), calc(${clientY}px - 50%), 0)`;
        cursorInner.style.left = `${clientX}px`;
        cursorInner.style.top = `${clientY}px`;
      };

      const handleMouseDown = () => {
        setIsClicking(true);
      };

      const handleMouseUp = () => {
        setIsClicking(false);
      };

      const handleLinkMouseOver = () => {
        setIsHoveringLink(true);
      };

      const handleLinkMouseLeave = () => {
        setIsHoveringLink(false);
      };

      // Add event listeners
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mousedown", handleMouseDown);
      document.addEventListener("mouseup", handleMouseUp);

      const links = document.querySelectorAll("a");
      links.forEach((link) => {
        link.addEventListener("mouseover", handleLinkMouseOver);
        link.addEventListener("mouseleave", handleLinkMouseLeave);
      });

      // Cleanup event listeners on component unmount
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mousedown", handleMouseDown);
        document.removeEventListener("mouseup", handleMouseUp);
        links.forEach((link) => {
          link.removeEventListener("mouseover", handleLinkMouseOver);
          link.removeEventListener("mouseleave", handleLinkMouseLeave);
        });
      };
    }
  }, []);
  return (
    <div>
      <div
        className={`custom-cursor__cursor ${isClicking ? "click" : ""} ${
          isHoveringLink ? "custom-cursor__hover" : ""
        }`}
        ref={cursorRef}
      ></div>
      <div
        className={`custom-cursor__cursor-two ${
          isClicking ? "custom-cursor__innerhover" : ""
        }`}
        ref={cursorInnerRef}
      ></div>

     <header
  className="main-header sticky-header sticky-header--normal"
  style={{ paddingTop: "0px", paddingBottom: "0px" }} // Adjust values as needed
>

        <div className="header_logo_main">
          <Link to="/" className="logo_image">
            <img
              src="assets/headimg.jpg"
              alt="Cleenhearts HTML"
              style={{ width: "100%", height: "150px",padding: "1px" }}
            />
          </Link>
          <div
            className={`mobile-nav__btn mobile-nav__toggler ${
              nav ? "icon-close" : "icon-grid"
            }`}
            onClick={handleMobileNavToggle}
          ></div>
        </div>
      </header>

      <div
        className="mobile-nav__wrapper"
        style={{
          visibility: nav ? "visible" : "hidden",
          transform: nav ? "translateX(0%)" : "translateX(-100%)",
          transition: nav
            ? "transform 500ms ease 0ms, visibility 500ms ease 0ms, -webkit-transform 500ms ease 0ms"
            : "transform 500ms ease 500ms, visibility 500ms ease 500ms, -webkit-transform 500ms ease 500ms",
        }}
      >
        <div className="mobile-nav__overlay mobile-nav__toggler"></div>
        <div
          className="mobile-nav__content"
          style={{
            opacity: nav ? "1" : "0",
            visibility: nav ? "visible" : "hidden",
            transition: slide
              ? "opacity 500ms ease 500ms, visibility 500ms ease 500ms, transform 500ms ease 500ms, -webkit-transform 500ms ease 500ms"
              : "opacity 500ms ease 0ms, visibility 500ms ease 0ms, transform 500ms ease 0ms, -webkit-transform 500ms ease 0ms",
          }}
        >
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={() => setNav(!nav)}
          >
            <i className="fa fa-times"></i>
          </span>
          <div className="logo-box">
            <NavLink to="/" aria-label="logo image">
              <img src="assets/logo.png" width="155"  alt="" />
            </NavLink>
          </div>
          <nav>
            <ul className="side-menu__list">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/aboutus">About Us</NavLink>
              </li>

              {/* Program Dropdown */}
              <li
                className="dropdown"
                onClick={() => handleDropdownToggle("program")}
                style={{
                  display: "flex",
                  width: "94%",
                  justifyContent: "space-between",
                }}
              >
                <NavLink
                  to=""
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  Program
                  <FontAwesomeIcon
                    icon={faCaretDown}
                    rotation={openDropdown === "program" ? 0 : 270}
                  />
                </NavLink>
                {openDropdown === "program" && (
                  <div
                    className="Dropdown_program"
                    style={{ position: "relative" }}
                  >
                    <ul>
                      <li>
                        <NavLink to="/trainingprogram">
                          Training programme
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/studentsactivity">
                          Students activity
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/agricultureprogram">
                          Agriculture program
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/medical">Medical programme</NavLink>
                      </li>
                      <li>
                        <NavLink to="/Sportsactivities">
                          Sports activities
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                )}
              </li>

              {/* Certificate Dropdown */}

              <li
                className="dropdown"
                onClick={() => handleDropdownToggle("Certificate")}
                style={{
                  display: "flex",
                  width: "94%",
                  justifyContent: "space-between",
                }}
              >
                <NavLink
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  Certificate
                  <FontAwesomeIcon
                    icon={faCaretDown}
                    rotation={openDropdown === "donate" ? 0 : 270}
                  />
                </NavLink>
                {openDropdown === "Certificate" && (
                  <div
                    className="Dropdown_program"
                    style={{ position: "relative" }}
                  >
                    {/* <ul>
                    <li><NavLink to="/donate">Via QR</NavLink></li>
                    <li><NavLink to='/donate_account'>Via Acc</NavLink></li>
                  </ul> */}
                    <ul>
                      {certificates.length > 0 ? (
                        certificates.map((certificate) => (
                          <li key={certificate.id}>
                            <a
                              href={`${process.env.REACT_APP_API}/uploads/SubCategories/Images/${certificate.file_name}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {certificate.title}
                            </a>
                          </li>
                        ))
                      ) : (
                        <li></li>
                      )}
                    </ul>
                  </div>
                )}
              </li>

              {/* Exam Dropdown */}
              <li className="dropdown">
                <NavLink to="/exam">Exam portal</NavLink>
              </li>

              {/* Login Dropdown */}
              <li
                className="dropdown"
                onClick={() => handleDropdownToggle("login")}
                style={{
                  display: "flex",
                  width: "94%",
                  justifyContent: "space-between",
                }}
              >
                <NavLink
                  to=""
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  Login
                  <FontAwesomeIcon
                    icon={faCaretDown}
                    rotation={openDropdown === "login" ? 0 : 270}
                  />
                </NavLink>
                {openDropdown === "login" && (
                  <div
                    className="Dropdown_program"
                    style={{ position: "relative" }}
                  >
                    <ul style={{ margin: "10px" }}>
                      {!localStorage.getItem("isLoggedIn") ? (
                        <li>
                          <NavLink to="/login">Admin Login</NavLink>
                        </li>
                      ) : localStorage.getItem("userRole") === "supperadmin" ? (
                        <li>
                          <NavLink to="/admin">Admin</NavLink>
                        </li>
                      ) : localStorage.getItem("userRole") === "admin" ? (
                        <li>
                          <NavLink to="/admin">Admin</NavLink>
                        </li>
                      ) : null}

                      {!localStorage.getItem("isInstitutionLogin") ? (
                        <li>
                          <NavLink to="/institution-login">
                            Institution Login
                          </NavLink>
                        </li>
                      ) : (
                        <li>
                          <NavLink to="/institution">Institution</NavLink>
                        </li>
                      )}
                      {/* <li><NavLink to="/institution-login">Institution Login</NavLink></li> */}
                      <li>
                        <NavLink to="/studentlogin">Student Login</NavLink>
                      </li>
                      <li>
                        <NavLink to="/coordinator-login">
                          Coordinator Login
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/register">Register Here</NavLink>
                      </li>
                    </ul>
                  </div>
                )}
              </li>

              <li>
                <NavLink to="/contact">Contact Us</NavLink>
              </li>

              <li>
                <NavLink to="/donate">Donate</NavLink>
              </li>
            </ul>
          </nav>

          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-envelope"></i>
              <a href="mailto:info@ramjitrust.org">info@ramjitrust.org</a>
            </li>
            <li>
              <i className="fa fa-phone-alt"></i>
              <a href="tel:+919843976039">+91 98439 76039</a>
            </li>
          </ul>

          <div className="mobile-nav__social">
            <a href="http://facebook.com/">
              <i className="fab fa-facebook-f" aria-hidden="true"></i>
              <span className="sr-only">Facebook</span>
            </a>
            <a href="http://twitter.com/">
              <i className="fab fa-twitter" aria-hidden="true"></i>
              <span className="sr-only">Twitter</span>
            </a>
            <a href="http://linkedin.com/" aria-hidden="true">
              <i className="fab fa-linkedin-in"></i>
              <span className="sr-only">Linkedin</span>
            </a>
            <a href="http://youtube.com/" aria-hidden="true">
              <i className="fab fa-youtube"></i>
              <span className="sr-only">Youtube</span>
            </a>
          </div>
        </div>
      </div>

      <Stickeyheader />
    </div>
  );
};

export default Header;
